export default __webpack_public_path__ + "static/media/layout.970bdea8.svg";